import React, { useState, useEffect } from 'react';
import './PremiumCardCollection.css'; // We'll create this CSS file

function PremiumCardCollection() {
    const [currentPage, setCurrentPage] = useState(1);
    const [cards, setCards] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [totalPages, setTotalPages] = useState(1);
    const [totalItems, setTotalItems] = useState(0);
    const [totalValue, setTotalValue] = useState(0);

    // Mock data - replace with actual API call
    const fetchCardCollection = async (page = 1) => {
        try {
            setLoading(true);
            // Simulate API call
            const mockData = {
                cards: [
                    {
                        id: "N/A",
                        set_series: "N/A",
                        card_name: "N/A",
                        card_no: "N/A",
                        price_paid: 0.00,
                        want_to_sell: "N/A",
                        seller: "N/A",
                        notes: "N/A",
                        added_date: "N/A"
                    },

                ],
                pagination: {
                    current_page: 1,
                    last_page: 1,
                    total: 3
                }
            };

            // Calculate total value
            const total = mockData.cards.reduce((sum, card) => sum + card.price_paid, 0);
            setTotalValue(total);
            setCards(mockData.cards);
            setTotalPages(mockData.pagination.last_page);
            setTotalItems(mockData.pagination.total);
            setError('');
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchCardCollection(1);
    }, []);

    const handlePageChange = (newPage) => {
        setCurrentPage(newPage);
        fetchCardCollection(newPage);
    };

    const formatDate = (dateString) => {
        if (!dateString) return 'N/A';
        try {
            const date = new Date(dateString);
            return date.toLocaleDateString('en-US', {
                year: 'numeric',
                month: 'short',
                day: 'numeric'
            });
        } catch (e) {
            return dateString;
        }
    };

    const getSellStatusClass = (status) => {
        return status?.toLowerCase() === 'yes' ? 'sell-yes' : 'sell-no';
    };

    const LoadingIcon = () => (
        <div className="loading-container">
            <div className="loading-spinner"></div>
            <p>Loading card collection...</p>
        </div>
    );

    const handleRetry = () => {
        fetchCardCollection(currentPage);
    };

    // Generate pagination page numbers
    const generatePageNumbers = () => {
        const pageNumbers = [];
        
        if (totalPages <= 5) {
            for (let i = 1; i <= totalPages; i++) {
                pageNumbers.push(i);
            }
        } else {
            pageNumbers.push(1);
            let start = Math.max(2, currentPage - 1);
            let end = Math.min(totalPages - 1, currentPage + 1);
            
            if (currentPage <= 3) {
                end = 4;
            }
            if (currentPage >= totalPages - 2) {
                start = totalPages - 3;
            }
            
            if (start > 2) {
                pageNumbers.push('...');
            }
            for (let i = start; i <= end; i++) {
                pageNumbers.push(i);
            }
            if (end < totalPages - 1) {
                pageNumbers.push('...');
            }
            pageNumbers.push(totalPages);
        }
        return pageNumbers;
    };

    return (
        <div className="refer-container1">
            {/* Summary Card for Total Value */}
            <div className="total-value-card">
                <div className="total-value-content">
                    <h3>Total Collection Value</h3>
                    <p className="total-value-amount">${totalValue.toFixed(2)}</p>
                </div>
            </div>

            {/* Table Content */}
            <div className="table-container3">
                {loading ? (
                    <LoadingIcon />
                ) : error ? (
                    <div className="error-container">
                        <div className="error-icon">⚠️</div>
                        <h3>Error Loading Data</h3>
                        <p>{error}</p>
                        <button className="retry-btn" onClick={handleRetry}>
                            Retry
                        </button>
                    </div>
                ) : (
                    <>
                        <div className="table-responsive">
                            <table className="card-table">
                                <thead>
                                    <tr>
                                        <th>No</th>
                                        <th>Set/Series</th>
                                        <th>Card Name</th>
                                        <th>Card No</th>
                                        <th>Price Paid</th>
                                        <th>Want to sell?</th>
                                        <th>Seller</th>
                                        <th>Notes</th>
                                        <th>History</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {cards.length > 0 ? (
                                        cards.map((card, index) => {
                                            const itemNumber = (currentPage - 1) * 10 + index + 1;
                                            
                                            return (
                                                <tr key={card.id}>
                                                    <td>{itemNumber}</td>
                                                    <td className="series-cell">{card.set_series || 'N/A'}</td>
                                                    <td className="name-cell">{card.card_name || 'N/A'}</td>
                                                    <td>{card.card_no || 'N/A'}</td>
                                                    <td className="price-cell">${(card.price_paid || 0).toFixed(2)}</td>
                                                    <td>
                                                        <span className={`sell-badge ${getSellStatusClass(card.want_to_sell)}`}>
                                                            {card.want_to_sell || 'N/A'}
                                                        </span>
                                                    </td>
                                                    <td>{card.seller || 'N/A'}</td>
                                                    <td className="notes-cell">{card.notes || '—'}</td>
                                                    <td>
                                                        <button 
                                                            className="history-btn"
                                                            onClick={() => console.log('View history for card:', card.id)}
                                                        >
                                                            View
                                                        </button>
                                                    </td>
                                                </tr>
                                            );
                                        })
                                    ) : (
                                        <tr>
                                            <td colSpan="9">
                                                <div className="empty-state">
                                                    <div className="empty-icon">🎴</div>
                                                    <h3>No Cards Found</h3>
                                                    <p>Start adding cards to your premium collection!</p>
                                                </div>
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>

                        {/* Pagination */}
                        {totalPages > 1 && cards.length > 0 && (
                            <div className="pagination-container">
                                <div className="pagination-info">
                                    Showing {(currentPage - 1) * 10 + 1} to {Math.min(currentPage * 10, totalItems)} of {totalItems} entries
                                </div>
                                <div className="pagination">
                                    <button 
                                        className="page-btn prev-next first-page" 
                                        onClick={() => handlePageChange(1)}
                                        disabled={currentPage === 1}
                                        title="First Page"
                                    >
                                        «
                                    </button>
                                    <button 
                                        className="page-btn prev-next" 
                                        onClick={() => handlePageChange(currentPage - 1)}
                                        disabled={currentPage === 1}
                                    >
                                        ← Previous
                                    </button>
                                    
                                    <div className="page-numbers">
                                        {generatePageNumbers().map((pageNum, index) => {
                                            if (pageNum === '...') {
                                                return (
                                                    <span key={`ellipsis-${index}`} className="page-ellipsis">
                                                        ...
                                                    </span>
                                                );
                                            }
                                            return (
                                                <button
                                                    key={pageNum}
                                                    className={`page-btn ${currentPage === pageNum ? "active" : ""}`}
                                                    onClick={() => handlePageChange(pageNum)}
                                                >
                                                    {pageNum}
                                                </button>
                                            );
                                        })}
                                    </div>
                                    
                                    <button 
                                        className="page-btn prev-next" 
                                        onClick={() => handlePageChange(currentPage + 1)}
                                        disabled={currentPage === totalPages}
                                    >
                                        Next →
                                    </button>
                                    <button 
                                        className="page-btn prev-next last-page" 
                                        onClick={() => handlePageChange(totalPages)}
                                        disabled={currentPage === totalPages}
                                        title="Last Page"
                                    >
                                        »
                                    </button>
                                </div>
                                
                                <div className="page-jump">
                                    <span>Go to page: </span>
                                    <input
                                        type="number"
                                        min="1"
                                        max={totalPages}
                                        defaultValue={currentPage}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                const page = parseInt(e.target.value);
                                                if (page >= 1 && page <= totalPages) {
                                                    handlePageChange(page);
                                                }
                                            }
                                        }}
                                        className="page-input"
                                    />
                                </div>
                            </div>
                        )}
                    </>
                )}
            </div>
        </div>
    );
}

export default PremiumCardCollection;